// NoticeList.jsx
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Notice.module.css";

export default function NoticeList() {
  const [data, setData] = useState({ content: [], totalPages: 0, number: 0 });
  const [page, setPage] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`/api/support/notices?page=${page}&size=10`, { credentials: "include" })
      .then((res) => res.json())
      .then(setData);
  }, [page]);

  return (
    <main className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>공지사항</h1>
      </div>

      <table className={styles.table}>
        <thead>
          <tr>
            {/* <th style={{ width: "60px" }}>번호</th> */}
            <th>제목</th>
            <th style={{ width: "160px" }}>작성일</th>
          </tr>
        </thead>
        <tbody>
          {data.content.map((n, idx) => (
            <tr key={n.id} onClick={() => navigate(`/support/notices/${n.id}`)}>
              {/* <td>{data.totalElements - (data.number * 10 + idx)}</td> */}
              <td className={n.pinned ? styles.pinned : ""}>{n.title}</td>
              <td>{n.createdAt?.slice(0, 10)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* 단순 페이지네이션 예시 */}
      <div className={styles.pagination}>
        <button disabled={page === 0} onClick={() => setPage((p) => p - 1)}>
          이전
        </button>
        <span>{page + 1} / {data.totalPages || 1}</span>
        <button
          disabled={page + 1 >= data.totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          다음
        </button>
      </div>
    </main>
  );
}
